import produce from 'immer';
import { ActionTypes } from './Settings.actions';

export const initialState = {
    fetchingUserData: false,
    exportedData: {},
    consents: [],
    sessions: [],
    notifications: []
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.exportUserData: {
            draft.fetchingUserData = true;
            return draft;
        }
        case ActionTypes.exportUserDataCompleted: {
            const { exportedData } = action.payload;
            draft.exportedData = exportedData;
            draft.fetchingUserData = false;
            return draft;
        }
        case ActionTypes.fetchPrivacyConsentsCompleted: {
            const { consents } = action.payload;
            draft.consents = consents;
            return draft;
        }
        case ActionTypes.updatePrivacyConsent: {
            const { consentId, isChecked } = action.payload;
            draft.consents.find((consent) => consent.consentId === consentId).isChecked = isChecked;
            return draft;
        }
        case ActionTypes.fetchActiveSessionsCompleted: {
            const { sessions } = action.payload;
            draft.sessions = sessions;
            return draft;
        }
        case ActionTypes.logoutFromSessionCompleted: {
            const { sessionId } = action.payload;
            draft.sessions = draft.sessions.filter((session) => session.sessionId !== sessionId);
            return draft;
        }
        case ActionTypes.fetchNotificationsCompleted: {
            const { notifications } = action.payload;
            draft.notifications = notifications;
            return draft;
        }
        case ActionTypes.updateNewApplicationEmailNotification: {
            const { notificationId, isChecked } = action.payload;
            draft.notifications.find((notification) => notification.notificationId === notificationId).isChecked = isChecked;
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;
